import {React, useState} from 'react'
import Groups from './Groups/Groups'
import Permissions from './Permissions/Permissions';
import { Modal, Switch, Form } from 'antd';
import { MdOutlineSecurity } from "react-icons/md";
import { FaUsersCog } from "react-icons/fa";
import styles from "./styles.module.css"


function UserGroups() {

    const [isUserGroupSelected, setIsUserGroupSelected] = useState(true)

  return (
    <div className='container'>
    {/* <Form.Item label={isUserGroupSelected ? "UserGroups" : "Permissions"} valuePropName="checked">
        <Switch checked={isUserGroupSelected} onChange={(checked) => setIsUserGroupSelected(checked)} />
    </Form.Item> */}
    <Switch checkedChildren={<FaUsersCog/>} unCheckedChildren={<MdOutlineSecurity/>} checked={isUserGroupSelected}
     onChange={(checked) => setIsUserGroupSelected(checked)}  className={styles["custom-toggle"]}/>
    {isUserGroupSelected ? <Groups/> : <Permissions/>}
    {/* <div><Groups></Groups></div> */}
    
    
    </div>
    

  )
}

export default UserGroups